import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal'
import type { ReactElement } from 'react'
import { useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import scriptLoader from 'react-async-script-loader'
import type { FileDetailsResponse } from '../../../interfaces/FileDetailsResponse'
import type { MediaLibrarySearchFileResponse } from '../../../interfaces'
import CCEditor from './CCEditor'
import { MLContext } from '../../../providers'
import { MediaLibraryActions } from '../../../providers/MLProvider'

interface Props {
  fileDetails: FileDetailsResponse | MediaLibrarySearchFileResponse
  isOpen: boolean
  onClose(): void
  getFileDetails(): Promise<FileDetailsResponse> | Promise<void>
}

const CustomFoucsAreaModal = ({
  fileDetails,
  isOpen,
  onClose,
  getFileDetails,
}: Props): ReactElement => {
  const { t } = useTranslation()
  const [, dispatch] = useContext(MLContext)

  useEffect(() => {
    if (!fileDetails && isOpen) {
      onClose()
    }
  }, [fileDetails])

  if (!fileDetails) {
    return <></>
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        dispatch({ type: MediaLibraryActions.DESELECT_ALL_FILES_AND_FOLDERS })
        onClose()
      }}
      size="full"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('custom_focus_area', 'Custom Focus Area')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <CCEditor
            onClose={onClose}
            selectedFile={fileDetails}
            getFileDetails={getFileDetails}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default scriptLoader<Props>([
  'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/4.1.0/fabric.min.js',
])(CustomFoucsAreaModal)
